import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges
} from '@angular/core';
import { PopoverOptions } from '@ipreo/ngx-sprinkles';
import { RATING_AGENCIES } from '../../../helpers/issue/ratings';
import { BasicDeal, Rating } from '../../../types/deal.types';
import { BaseAgencyRatingComponent } from '../base-agency-rating/base-agency-rating.component';

@Component({
  selector: 'muni-shared-brief-agency-rating',
  templateUrl: './brief-agency-rating.component.html',
  styleUrls: ['./brief-agency-rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BriefAgencyRatingComponent
  extends BaseAgencyRatingComponent
  implements OnChanges
{
  @Input()
  public deal: BasicDeal;

  @Input()
  public isUnderlyingViewOn: boolean;
  public cellContent: string | null;
  public tooltipContent: string | null;

  public tooltipOptions: Partial<PopoverOptions> = {
    placement: 'top',
    popperOptions: {
      modifiers: [
        { name: 'preventOverflow', options: { boundary: 'viewport', padding: 8 } },
        { name: 'hide', options: { padding: 8 } },
        { name: 'offset', options: { offset: [0, 8] } }
      ]
    } as any
  };

  ngOnChanges() {
    super.ngOnChanges();
    if (!this.allEnhanced) {
      this.cellContent = this.getDisplayValue(this.ratings);
      if (!this.cellContent) {
        this.cellContent = this.getDisplayValue(this.underlyingRatings);
      }
      this.tooltipContent = null;
      return;
    }
    if (this.isUnderlyingViewOn) {
      this.cellContent = this.getDisplayValue(this.underlyingRatings);
      this.tooltipContent = this.getDisplayValue(this.ratings);
      this.tooltipOptions = {
        ...this.tooltipOptions,
        theme: 'underlying-view'
      };
    } else {
      this.cellContent = this.getDisplayValue(this.ratings);
      this.tooltipContent = this.getDisplayValue(this.underlyingRatings);
      this.tooltipOptions = { ...this.tooltipOptions, theme: 'deal-view' };
    }
  }
  protected get seriesList() {
    return this.deal.series;
  }

  protected get automationName() {
    const agency = RATING_AGENCIES.find((a) => a.name === this.agencyName);
    return `${agency.key}-deal`;
  }

  private getDisplayValue(ratings: Rating[]): string | null {
    return this.reduceValues(ratings);
  }
}
